import Logo from '@assets/logo.svg?react';
import { Menu } from '@components/menu';
import { Notifications } from '@components/Notifications/Notifications';
import { Alert, AlertType, CloseIcon, Loader, MenuIcon } from '@gurupay/gp-ui-library';
import useAnnouncements from '@hooks/useAnnouncements';
import clsx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { Link, Outlet } from 'react-router-dom';

import { ErrorBoundary } from '../../ErrorBoundary';

export const PageLayout = () => {
	const { t } = useTranslation();
	const isMobileMenu = useMediaQuery({ query: '(max-width: 767px)' });
	const { data, isLoading } = useAnnouncements();

	const [isMenuOpen, setIsMenuOpen] = useState(false);

	return (
		<div className="bg-neutral-50 min-h-screen max-md:pt-[64px]">
			{isMobileMenu ? (
				<>
					<div className="fixed w-full bg-neutral-50 flex items-center pt-space-8 justify-between px-space-16 min-md:px-space-48 top-0 h-[72px] z-[101]">
						<Link to="/">
							<Logo className="flex-[50px] flex-shrink-0 flex-grow-0" />
						</Link>

						<Notifications announcements={data} className="ml-auto mr-space-16" />

						{isMenuOpen ? (
							<CloseIcon onClick={() => setIsMenuOpen(false)} />
						) : (
							<MenuIcon onClick={() => setIsMenuOpen(true)} />
						)}
					</div>

					<Menu
						className={clsx(
							'fixed w-full shrink-0 p-space-16 z-100 transition-all duration-300 ease-linear left-0 top-0',
							isMenuOpen ? 'top-0' : '-translate-y-full',
						)}
						onLinkClick={() => setIsMenuOpen(false)}
					/>
				</>
			) : (
				<Menu className="fixed top-0 min-md:w-[264px] shrink-0 p-space-16" />
			)}

			<div className="p-space-24 max-md:px-space-16 min-md:pr-space-24 min-md:ml-[264px] space-y-space-8">
				<ErrorBoundary
					fallback={<Alert type={AlertType.ERROR}>{t('common.failed')}</Alert>}
				>
					{!isMobileMenu && <Notifications announcements={data} className="ml-auto" />}

					{isLoading ? (
						<div className="flex items-center justify-center min-h-[90vh]">
							<Loader />
						</div>
					) : (
						<Outlet />
					)}
				</ErrorBoundary>
			</div>
		</div>
	);
};
